import { render, staticRenderFns } from "./Item13.vue?vue&type=template&id=69120c91&"
import script from "./Item13.vue?vue&type=script&lang=js&"
export * from "./Item13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports